import axios from 'axios';

const API_URL = (process.env.REACT_APP_NEXTLOG_API_URL);

const api = {
  // Most Recent Execution (replaces old execution status APIs)
  getMostRecentExecution: async (module) => {
    return axios.get(`${API_URL}/get_executions`, {
      params: {
        module,
        sort: 'timestamp_start',
        sort_order: 'desc',
        page: 1,
        page_size: 1
      }
    });
  },

  // Get Running Execution (for progress banner)
  getRunningExecution: async (module = "") => {
    return axios.get(`${API_URL}/get_running_execution`, { params: { module } });
  },

  
  // Case Attribution Results Per Message
  getCaseAttributionResults: async (params = {}, data) => {
    return axios.post(`${API_URL}/case_attribution_execution_results_per_message`, data, {
      params: params
    });
  },
  
  // Classification Results Per Message
  getClassificationResults: async (params = {}, data) => {
    return axios.post(`${API_URL}/classification_execution_results_per_message`, data, {
      params: params
    });
  },
  
  // Execution Result
  getExecutionResult: async (executionId, module = "message_classification") => {
    return axios.get(`${API_URL}/execution_result`, { 
      params: { execution_id: executionId, module } 
    });
  },

  // Get Execution
  getExecution: async (executionId) => {
    return axios.get(`${API_URL}/get_execution`, { params: { execution_id: executionId } });
  },

  // get Executions
  getExecutions: async (module = "message_classification", sort = "timestamp_start", sort_order = "desc", page=1, page_size=10) => {
    return axios.get(`${API_URL}/get_executions`, { params: { module, sort, sort_order, page, page_size } });
  },

  // Basic Statistics
  getBasicStatistics: async () => {
    return axios.get(`${API_URL}/basic_statistics`);
  },
  
  // Message Details
  getMessageDetails: async (messageIds) => {
    return axios.post(`${API_URL}/message_details`, { message_ids: messageIds });
  },
  
  // Run Module Case Attribution
  runCaseAttribution: async (selection = "all", run_in_background = true) => {
    return axios.get(`${API_URL}/run_module_case_attribution`, { params: { selection, run_in_background } });
  },
  
  // Run Module Message Classifier
  runMessageClassifier: async (caseSelection = "all", run_in_background = true) => {
    return axios.get(`${API_URL}/run_module_message_classifier`, { params: { case_selection: caseSelection, run_in_background } });
  },
  
  // Run Module Message Summarizer
  runMessageSummarizer: async (run_in_background = true, max_workers = null, max_retries = null, chunk_size = null) => {
    const params = { run_in_background };
    if (max_workers !== null) params.max_workers = max_workers;
    if (max_retries !== null) params.max_retries = max_retries;
    if (chunk_size !== null) params.chunk_size = chunk_size;
    return axios.post(`${API_URL}/run_module_message_summarizer`, null, { params });
  },
  
  // Get Process Graph
  getProcessGraph: async (dbSource = "mixed_events", type = "ddfg1") => {
    return axios.get(`${API_URL}/visualize_process_graph`, { params: { db_source: dbSource, type } });
  },
  
  // Get Process Graph Description (for advanced widget)
  getProcessGraphDescription: async (dbSource = "source_events") => {
    return axios.get(`${API_URL}/process_graph_description`, { params: { db_source: dbSource } });
  },

  // Run Module Process Guesser
  // runProcessGuesser: async (params = {}) => {
  //   return axios.post(`${API_URL}/run_module_process_guesser`, null, { params });
  // },
  runProcessGuesser: async (reference_event_master=null, params = {}) => {
    return axios.post(`${API_URL}/run_module_process_guesser`, reference_event_master, { params: params });
  },

  // Get Event Master Suggestion by Execution ID
  getEventMasterSuggestion: async (executionId) => {
    return axios.get(`${API_URL}/get_event_master_suggestion_by_execution_id`, { params: { execution_id: executionId } });
  },

  // Get Most Recent Event Master Suggestion
  getMostRecentEventMasterSuggestion: async () => {
    return axios.get(`${API_URL}/get_most_recent_event_master_suggestion`);
  },

  // Get Event Master
  getEventMaster: async () => {
    return axios.get(`${API_URL}/event_master`);
  },

  // Set Event Master
  setEventMaster: async (eventMasterList, params={}) => {
    return axios.post(`${API_URL}/event_master`, eventMasterList);
  },

  // Reset Processing Demo
  resetProcessingDemo: async () => {
    return axios.get(`${API_URL}/reset_processing_demo`);
  },

  // Cancel Execution
  cancelExecution: async (override = false) => {
    return axios.get(`${API_URL}/cancel_execution`, { params: { override } });
  },

  // Get Events as CSV
  getEventsAsCSV: async (type = "native_events") => {
    return axios.get(`${API_URL}/events`, {
      params: { type },
      responseType: 'blob'
    });
  },

  // Get Cases
  getCases: async (filter = {}, sort = "case_id", sortOrder = "asc", page = 1, pageSize = 10) => {
    return axios.post(`${API_URL}/cases`, {
      filter,
      sort,
      sort_order: sortOrder,
      page,
      page_size: pageSize
    });
  },

  // Get Case Details
  getCaseDetails: async (caseId) => {
    return axios.get(`${API_URL}/get_case_details`, {
      params: { case_id: caseId }
    });
  },

  // Get Prompt Logs
  getPromptLogs: async (sort = "timestamp", sortOrder = "desc", page = 1, pageSize = 10) => {
    return axios.get(`${API_URL}/prompt_logs`, {
      params: {
        sort,
        sort_order: sortOrder,
        page,
        page_size: pageSize
      }
    });
  },

  // Get Token Usage Statistics
  getTokenUsageStatistics: async (months = 3) => {
    return axios.get(`${API_URL}/token_usage_statistics`, {
      params: { months }
    });
  }
};

export default api;